import { useMemo } from 'react'
import { OrderType } from 'types/checkout'

const useSumOrderAmount = (userIds: string[], orders: OrderType[]): number => {
  return useMemo(() => {
    let amount = 0
    for (let i = 0; i < userIds.length; i = (i + 1) | 0) {
      const userId = userIds[i]
      // 受取番号に対応する注文が存在するならカウントアップ
      if (orders.some((order) => order.user_id === userId)) amount++
    }
    return amount
  }, [userIds, orders])
}

export default useSumOrderAmount
